/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TimesheetArray } from '../models/TimesheetArray'
import type { TimesheetsTotals } from '../models/TimesheetsTotals'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class TimesheetsService {
  /**
   * 👤 Get all timesheets between start and end
   * @param start
   * @param end
   * @returns any OK
   * @throws ApiError
   */
  public static getTimesheets(
    start: string,
    end: string,
  ): CancelablePromise<{
    data?: TimesheetArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/timesheets/{start}/{end}',
      path: {
        start: start,
        end: end,
      },
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
      },
    })
  }
  /**
   * 👤 Downloads the timesheet for the given month
   * @param month
   * @returns binary OK
   * @throws ApiError
   */
  public static downloadTimesheet(month: string): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/timesheet/download/{month}',
      path: {
        month: month,
      },
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
      },
    })
  }
  /**
   * 👤 Get total flextimeBalance and holidays
   * @returns any OK
   * @throws ApiError
   */
  public static getTotals(): CancelablePromise<{
    data?: TimesheetsTotals
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/timesheets/totals',
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
      },
    })
  }
}
